import { createContext, useContext, useState } from "react";

export const BookingContext = createContext({});
export const useBookingContext = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [modal, setModal] = useState(false);
  const [openZone1, setOpenZone1] = useState(false);
  const [openZone2, setOpenZone2] = useState(false);
  const [openZoneOutsideIsland, setOpenZoneOutsideIsland] = useState(false);
  const [openInTownModal, setOpenInTownModal] = useState(false);
  const [openOutOfTownModal, setOpenOutOfTownModal] = useState(false);
  const [dateUsage, setDateUsage] = useState({ inTown: [], outOfTown: [], outOfIsland: [] });
  const [aditionalItem, setAditionalItem] = useState({
    umbrella: 0,
    baby_seat: 0,
  });

  const value = {
    modal,
    setModal,
    data,
    setData,
    dateUsage,
    setDateUsage,
    openOutOfTownModal,
    setOpenOutOfTownModal,
    aditionalItem,
    setAditionalItem,
    openInTownModal,
    setOpenInTownModal,
    openZone1,
    setOpenZone1,
    openZone2,
    setOpenZone2,
    openZoneOutsideIsland,
    setOpenZoneOutsideIsland,
  };

  return (
    <BookingContext.Provider value={value}>{children}</BookingContext.Provider>
  );
};
